import Select from 'react-select';

const FilterSelect = (props) => {
  return (
    <Select
      {...props}
      className='filter-select'
      styles={{
        control: (baseStyles) => ({
          ...baseStyles,
          minHeight: '24px',
          height: '24px',
        }),
        valueContainer: (baseStyles) => ({
          ...baseStyles,
          padding: '0 8px',
        }),
        input: (baseStyles) => ({
          ...baseStyles,
          margin: 0,
          padding: 0,
          height: '22px'
        }),
        dropdownIndicator: (baseStyles) => ({
          ...baseStyles,
          padding: '0 4px',
        }),
        clearIndicator: (baseStyles) => ({
          ...baseStyles,
          padding: '0 4px',
        }),
      }}
      isClearable
      isSearchable
    />
  );
}

export default FilterSelect;
